'use client';

import { Link } from '@coolblue-development/freddy';
import selectItemInItemCardTrigger from '@coolblue-development/ga4-events/triggers/ItemCard/selectItemInItemCardTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitle } from '@coolblue-development/next-patterns/client';
import { FilterPageProduct } from '@features/filter/types';
import { ReactElement } from 'react';

import { ReviewsSection } from './ReviewsSection';

interface ProductCardTitleProps {
  product: FilterPageProduct;
  salesPriceComponent: ReactElement;
  index: number;
  total_indices: number;
  productPageLink: string;
}

export const Title = ({
  product,
  salesPriceComponent,
  index,
  total_indices,
  productPageLink
}: ProductCardTitleProps) => {
  const { name, id } = product;

  const { trackEvent } = useAnalytics();

  return (
    <ProductTitle>
      <ProductTitle.Title size='medium'>
        <Link
          href={productPageLink}
          onClick={() =>
            trackEvent(
              selectItemInItemCardTrigger({
                index: index,
                total_indices: total_indices,
                method: 'title',
                item_id: Number(id)
              })
            )
          }
        >
          {name}
        </Link>
      </ProductTitle.Title>

      <ReviewsSection product={product} salesPrice={salesPriceComponent} />
    </ProductTitle>
  );
};
